export default __webpack_public_path__ + "static/media/AnovaUI-BoldItalic.fc04af15.woff2";